import React from 'react'
import ReactGA from 'react-ga4'
import Icon from '../misc/Icons'
import UpgradeProFeaturesSymbolRow from './UpgradeProFeaturesSymbolRow'
import analytics from '../../utils/cdpAnalytics'

class UpgradeSuccessPage extends React.Component {
  componentDidMount() {
    let testGroup = null
    const setLimitTestGroup = JSON.parse(localStorage.getItem('meta.setGroup'))
    if (setLimitTestGroup) {
      testGroup = setLimitTestGroup
    }

    analytics.page('Upgrade', {
      stage: 'Success',
      // eslint-disable-next-line camelcase
      test_group_set_limit: testGroup,
    })
    if (typeof window.gtag === 'function') {
      ReactGA.set({ page: '/upgrade-success-page' })
      ReactGA.send({ hitType: 'pageview' })
    }

    this.triggerServiceSync()
  }

  componentDidUpdate(prevProps) {
    // if service changes, trigger sync
    if (prevProps.service?.product !== this.props.service?.product) {
      this.triggerServiceSync()
    }
  }

  isUpgraded() {
    return this.props.service?.product === 'plus'
  }

  async triggerServiceSync() {
    const {
      service, fetchService, fetchBilling, fetchPreviewInvoice,
    } = this.props
    if (!service) return
    // if fetched service is free, refetch it
    if (service?.product === 'free') {
      setTimeout(fetchService, 1000)
    } else if (this.isUpgraded()) {
      // sync billing and invoice to make sure data is up to date
      // (sometimes they are inconsistent right upon upgrade)
      fetchBilling()
      fetchPreviewInvoice()
    }
  }

  render() {
    const { isOnTrial, service } = this.props

    const trialPurchase = isOnTrial
    const upgradeCompleted = service?.product === 'plus'

    return (
      <div className='upgrade upgrade--success marketing'>
        <div className='upgrade-closeBtn' onClick={this.props.hideModal}>
          <Icon name='circle-with-close' />
        </div>

        {!upgradeCompleted && (
          <React.Fragment>
            <div className='upgrade--success-sub upgrade--success-sub--loading'>
              We are setting up your Plickers Pro. This may take few seconds...
            </div>
            <div className='upgrade--success-sub upgrade--success-sub--loading-loadingSpinnerContainer'>
              <div className='upgrade--success-sub upgrade--success-sub--loading-loadingSpinner' />
            </div>
          </React.Fragment>
        )}

        {upgradeCompleted && (
        <React.Fragment>
          <div className='upgrade--success-header'>
            <span role='img' aria-label='Celebration'>🎉</span>
            {' '}
            &nbsp; Welcome to
            {' '}
            <span className='upgrade--success-header--plickersPro-plickers'>plickers</span>
            <span className='upgrade--success-header--plickersPro-pro'>pro</span>
            {' '}
            &nbsp; 🎉
          </div>

          {trialPurchase && (
          <div className='upgrade--success-sub'>
            You are now on a 14-day free trial. Here's everything that's included:
          </div>
          )}

          {!trialPurchase && (
          <div className='upgrade--success-sub'>
            Here's everything that's included:
          </div>
          )}

          <UpgradeProFeaturesSymbolRow />

          <div className='upgrade-success-btnContainer'>
            <button className='upgrade--success-doneBtn' onClick={this.props.hideModal}>
              Go to your upgraded Plickers
            </button>
          </div>

          {trialPurchase && (
          <div className='upgrade--success-cancelSub'>
            You can cancel your trial at any time by going to "Account", then "Cancel Trial".
          </div>
          )}
        </React.Fragment>
        )}
      </div>
    )
  }
}

export default UpgradeSuccessPage
